import React from 'react';
import Skeleton from '../../components/Skeleton';
import { getWindowWidth, isMobileScreen } from '../../services/utils';

const SavedSearchPageLoaderItem = ({ isMobile }) => (
  <div style={{
    display: "flex",
    gap: 10,
    marginTop: 10,
    padding: 15,
    flexDirection: isMobile ? "column" : "row"
  }}>
    {!isMobile && <Skeleton style={{ width: 100, height: 100 }} />}
    <div style={{ flex: 1 }}>
      <Skeleton style={{ marginBottom: 5, height: 20, width: 100 }} />
      <Skeleton style={{ marginBottom: 5, height: 20, width: isMobile ? "100%" : "80%" }} />
      <Skeleton style={{ marginBottom: 5, height: 20, width: 100 }} />
    </div>
    <div style={{ flex: 1 }}>
      <Skeleton style={{ height: 20, width: isMobile ? "100%" : 200 }} />
      {!isMobile && <Skeleton style={{ height: 20, width: 200 }} />}
    </div>
    {!isMobile && <Skeleton style={{ width: 100, height: 20 }} />}
  </div>
)

const SavedSearchPageLoader = () => {
  const isMobile = isMobileScreen(getWindowWidth());

  return (
    <React.Fragment>
      <SavedSearchPageLoaderItem isMobile={isMobile} />
      <SavedSearchPageLoaderItem isMobile={isMobile} />
      <SavedSearchPageLoaderItem isMobile={isMobile} />
    </React.Fragment>
  )
}


export default SavedSearchPageLoader;



// WEBPACK FOOTER //
// ./src/containers/SavedSearchPage/SavedSearchPageLoader.tsx